const mine_index = resolve =>{
  import('./mine_index/mine_index').then(module=>{
    resolve(module)
  })
}
const consume_record = resolve =>{
  import('./consume_record/consume_record').then(module=>{
    resolve(module)
  })
}

const newinvoice = resolve =>{
  import('./consume_record/invoice').then(module=>{
    resolve(module)
  })
}

const integral_record = resolve =>{
  import('./integral_record/integral_record').then(module=>{
    resolve(module)
  })
}
const invite_friends = resolve =>{
  import('./invite_friends/invite_friends').then(module=>{
    resolve(module)
  })
}
const mall_orders = resolve =>{
  import('./mall_orders/mall_orders').then(module=>{
    resolve(module)
  })
}

const orders_detail = resolve =>{
  import('./mall_orders/orders_detail').then(module=>{
    resolve(module)
  })
}
const mine_coupon = resolve =>{
  import('./mine_coupon/mine_coupon').then(module=>{
    resolve(module)
  })
}

const writeoff = resolve =>{
  import('./mine_coupon/writeoff').then(module=>{
    resolve(module)
  })
}

const washcar = resolve =>{
  import('./mine_coupon/washcar').then(module=>{
    resolve(module)
  })
}

const recharge_record = resolve =>{
  import('./recharge_record/recharge_record').then(module=>{
    resolve(module)
  })
}

const commission = resolve =>{
  import('./commission/commission').then(module=>{
    resolve(module)
  })
}

const withdraw = resolve =>{
  import('./commission/withdraw').then(module=>{
    resolve(module)
  })
}

const code = resolve =>{
  import('./code/code').then(module=>{
    resolve(module)
  })
};
const rules = resolve =>{
  import('./integral_record/rules').then(module=>{
    resolve(module)
  })
};
const recharge_card = resolve =>{
  import('./recharge_card/recharge_card').then(module=>{
    resolve(module)
  })
};
const recharge_card_record = resolve =>{
  import('./recharge_card/recharge_card_record').then(module=>{
    resolve(module)
  })
};

export default [
  {
    path: '/mine',
    name: 'mine_index',
    component: mine_index,
    meta: {
      auth: true,
      title: '个人中心',
      nav: true
    }
  },
  {
    name: 'consume_record',
    path: '/mine/consume_record',
    component: consume_record,
    meta: {
      nav: false,
      auth: true,
      title: '消费记录',
      keepAlive: false
    }
  },
  {
    name: 'newinvoice',
    path: '/mine/newinvoice',
    component: newinvoice,
    meta: {
      nav: false,
      auth: true,
      title: '开发票',
      keepAlive: false
    }
  },
  {
    name: 'integral_record',
    path: '/mine/integral_record',
    component: integral_record,
    meta: {
      nav: false,
      auth: true,
      title: '积分记录',
      keepAlive: false
    }
  },
  {
    name: 'rules',
    path: '/mine/integral_record/rules',
    component: rules,
    meta: {
      nav: false,
      auth: true,
      title: '积分规则',
      keepAlive: false
    }
  },
  {
    name: 'invite_friends',
    path: '/mine/invite_friends',
    component: invite_friends,
    meta: {
      nav: false,
      auth: true,
      title: '邀请好友',
      keepAlive: false
    }
  },
  {
    name: 'mall_orders',
    path: '/mine/mall_orders',
    component: mall_orders,
    meta: {
      nav: false,
      auth: true,
      title: '商城订单',
      keepAlive: false
    }
  },
  {
    name: 'orders_detail',
    path: '/mine/orders_detail',
    component: orders_detail,
    meta: {
      nav: false,
      auth: true,
      title: '订单详情',
      keepAlive: false
    }
  },
  {
    name: 'mine_coupon',
    path: '/mine/mine_coupon',
    component: mine_coupon,
    meta: {
      nav: false,
      auth: true,
      title: '优惠券',
      keepAlive: false
    }
  },
  {
    name: 'writeoff',
    path: '/mine/writeoff',
    component: writeoff,
    meta: {
      nav: false,
      auth: true,
      title: '优惠券核销',
      keepAlive: false
    }
  },
  {
    name: 'washcar',
    path: '/mine/washcar',
    component: washcar,
    meta: {
      nav: false,
      auth: true,
      title: '洗车券核销',
      keepAlive: false
    }
  },
  {
    name: 'recharge_record',
    path: '/mine/recharge_record',
    component: recharge_record,
    meta: {
      nav: false,
      auth: true,
      title: '充值记录',
      keepAlive: false
    }
  },
  {
    name: 'commission',
    path: '/mine/commission',
    component: commission,
    meta: {
      nav: false,
      auth: true,
      title: '佣金记录',
      keepAlive: false
    }
  },
  {
    name: 'withdraw',
    path: '/mine/withdraw',
    component: withdraw,
    meta: {
      nav: false,
      auth: true,
      title: '我要提现',
      keepAlive: false
    }
  },
  {
    name: 'myCode',
    path: '/mine/code',
    component: code,
    meta: {
      nav: false,
      auth: true,
      title: "我的二维码",
      keepAlive: false
    }
  },
  {
    name: 'recharge_card',
    path: '/mine/recharge_card',
    component: recharge_card,
    meta: {
      nav: false,
      auth: true,
      title: "充值卡充值",
      keepAlive: false
    }
  },
  {
    name: 'recharge_card_record',
    path: '/mine/recharge_card_record',
    component: recharge_card_record,
    meta: {
      nav: false,
      auth: true,
      title: "充值卡记录",
      keepAlive: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/module/mine/router.js